export const Modal = ({ children, overlayClasses, containerClassName }) => {
  return (
    <div className={overlayClasses}>
      <div className={containerClassName}>{children}</div>
    </div>
  )
}
